import React from 'react';

import { FlexBox, Text } from '@lumapps/lumx/react';
import { standardizeTranslateObject, useTranslate } from '@lumapps/translations';
import { EmptyStateRendererProps } from '@lumapps/widget-base/types';

import { WIDGET_CONTRIBUTION } from '../../keys';

import './index.scss';

const CLASSNAME = 'empty-editable-widget-contribution widget-content__placeholder';

export const EmptyEditableWidgetContribution: React.FC<EmptyStateRendererProps> = ({ widget, widgetContentStyle }) => {
    const customPlaceholder = widget?.legacyWidget?.properties?.helper;
    const { translateKey, translateObject } = useTranslate();

    return (
        <FlexBox
            style={widgetContentStyle}
            className={CLASSNAME}
            vAlign="center"
            hAlign="center"
            orientation="vertical"
        >
            <span className="widget-content__placeholder-title">{translateKey(WIDGET_CONTRIBUTION.EMPTY_WIDGET)}</span>
            {customPlaceholder && (
                <Text as="p" typography="body1" color="dark" colorVariant="L2">
                    {translateObject(standardizeTranslateObject(customPlaceholder))}
                </Text>
            )}
        </FlexBox>
    );
};
